module.exports = __webpack_public_path__ + "static/img/msg-box-error.488d429b.svg";